import React from 'react';
import type { ReactNode } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { CouponBanner } from '@root/components/www/home/coupon_banner';

import { Footer } from '@shared/content/footer';
import { Header } from '@shared/header/header';

import { Section, SectionDescriptor } from './section';

export const PageBuilder: React.FC<{
  sections?: SectionDescriptor[];
  title: string;
  description?: string;
  children?: ReactNode;
  customBanner?: ReactNode;
}> = ({ title, description, sections, customBanner, children }) => {
  return (
    <>
      <HelmetProvider context={global.helmetContext}>
        <Helmet>
          <title>{title}</title>
          {description && <meta name="description" content={description} />}
        </Helmet>
      </HelmetProvider>
      {!!customBanner ? customBanner : <CouponBanner />}
      <Header opaque />
      {children}
      {sections?.map((s) => <Section key={s.key} descriptor={s} />)}
      <Footer />
    </>
  );
};
